import clsx from 'clsx'
import React, { useState } from 'react'

import styles from './Circle.module.scss'
import { Flex } from '../flex/Flex'

interface CircleProps {
  className?: string
  text: string
  textOnHover: string
  onClick?: () => void
  style?: React.CSSProperties
}

const Circle = ({ className, text, textOnHover, onClick, style }: CircleProps) => {
  const [yellowCircle, setYellowCircle] = useState(false)
  const [circleText, setCircleText] = React.useState<string>(text)

  const onCircleMouseEnter = () => {
    setYellowCircle(true)
    setCircleText(textOnHover)
  }

  const onCircleMouseLeave = () => {
    setYellowCircle(false)
    setCircleText(text)
  }

  return (
    <Flex
      data-testid="circle-container"
      justify="center"
      className={clsx(styles.container, className)}
      onClick={onClick}
      style={style}
    >
      {yellowCircle ? (
        <Flex
          data-testid="big-circle"
          justify="center"
          className={styles.bigCircle}
          onMouseEnter={onCircleMouseEnter}
          onMouseLeave={onCircleMouseLeave}
        >
          <Flex className={styles.smallCircle}>
            <div className={styles.textContainer}>
              <p className={styles.textBlack}>{circleText}</p>
            </div>
          </Flex>
        </Flex>
      ) : (
        <Flex
          data-testid="small-circle"
          className={styles.circle}
          onMouseEnter={onCircleMouseEnter}
          onMouseLeave={onCircleMouseLeave}
        >
          <div className={styles.textContainer}>
            <p className={styles.textWhite}>{circleText}</p>
          </div>
        </Flex>
      )}
    </Flex>
  )
}

export default Circle
